import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import {
  breakpointDesktop,
  breakpointMobile,
  Modal,
} from "@gnist/design-system";
import React from "react";
import Image from "next/image";
import { styled } from "styled-components";
import { ImageContainer } from "@/components/styled-common/imageContainer";
import { tokens } from "@gnist/themes/tokens.css.js";

const ImageWrapper = styled.div`
  display: grid;
  grid-gap: ${tokens.spacing.s};
  grid-template-columns: 1fr;

  margin-bottom: 128px;
  margin-top: ${tokens.spacing.l};

  @media (min-width: ${breakpointMobile}) {
    margin: ${tokens.spacing.l} 15% 176px 15%;
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${breakpointDesktop}) {
    margin-left: 25%;
    margin-right: 25%;
  }
`;
const ExtendedImageContainer = styled(ImageContainer)`
  @media (min-width: ${breakpointMobile}) {
    &:nth-child(3n - 2) {
      grid-column: span 2;
    }
  }
`;

interface Props {
  car: Car;
  showAllImages: boolean;
  setShowAllImages: (x: boolean) => void;
}
export const CarImagesModal = ({
  car,
  showAllImages,
  setShowAllImages,
}: Props) => {
  return (
    <Modal
      isOpen={showAllImages}
      handleClose={() => setShowAllImages(false)}
      size={"fullscreen"}
    >
      <ImageWrapper>
        {car.carImages?.map((image) => (
          <ExtendedImageContainer key={image.normalUrl}>
            <Image
              fill={true}
              src={image.normalUrl}
              loader={(img) => img.src}
              unoptimized={true}
              sizes={"100%, 100%"}
              style={{ objectFit: "cover" }}
              alt={`Bilde av ${car.brand} ${car.model}`}
            ></Image>
          </ExtendedImageContainer>
        ))}
      </ImageWrapper>
    </Modal>
  );
};
